// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, "last", {
  enumerable: false,
  configurable: true,
  get: function () {
    return this[this.length - 1];
  },
  set: undefined,
});
